<template>
  <div class="row" ref="proxy">
    <div class="col-md-12 col-lg-12">
      <c-card title="범례" class="cardClassDetailInfo" topClass="topcolor-orange">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn label="적용" :editable="editable" icon="save" @btnClicked="saveData" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="row">
            <div class="col-xs-12 col-sm-12">
              <div class="col-xs-12 col-sm-12">
                <c-select
                  :editable="editable"
                  :isArray="false"
                  :comboItems="checkboxItems"
                  itemText="codeName"
                  itemValue="code"
                  label=""
                  name="checkItems"
                  v-model="checkItems"
                >
                </c-select>
              </div>
            </div>
          </div>
        </template>
      </c-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'equipment-deterior-result-proxy',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          deteriorCheckId: '',
        }
      },
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
    outFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: true,
      checkItem: null,
      checkboxItems: [
        { code: null, codeName: '선택'},
        { code: 'CHK001', codeName: '정상o'},
        { code: 'CHK002', codeName: '이상X'},
        { code: 'CHK003', codeName: '청소●'},
        { code: 'CHK004', codeName: '교환ν'},
        { code: 'CHK005', codeName: '마모□'},
        { code: 'CHK006', codeName: 'Oil 누유 △'},
        { code: 'CHK007', codeName: '점검필요 ▲'},
        { code: 'CHK008', codeName: '비가동 ⊙'},
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
    },
    reset() {
      Object.assign(this.$data.info, this.$options.data().info);
    },
    saveData() {
      
    },
  }
};
</script>